import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Missing from "assets/images/svg/missing_red.svg";
import {downloadFile, formatDate, json, showDiscriminate} from "helpers/data";
import ServerImage from "components/server-image/server-image";
import { ColoredLabel } from "components/classes";
import moment from "moment";
import { Button } from "components/form";
import { useTranslation } from "react-i18next";
import CanLoadGuard from "components/private-route/can-load.guard";
import ActivationFile from "./activationFile";
import { useModal } from "hooks";

const AddonsCad = ({
  addon: {
    image,
    isPurshased,
    addOnName,
    description,
    featuredTag,
    hasLabel,
    label,
    price,
    addOnId,
    addonSubscriptionId,
    versionId,
    priceLevelId,
    purshasedData,
  },
  onClick
}) => {
  const navigate = useNavigate();
  const [showActivationFile, openActivationFile, closeActivationFile] = useModal(false);

  const { id } = useParams();
  const { t } = useTranslation("browse-apps");
  const handleBuy = () => {
    navigate(
      `/Payment-details/?VersionId=${versionId}&PriceLevelId=${priceLevelId}&Discriminate=${price?.discrimination}&addOnId=${addOnId}&VersionSubscriptionId=${id}&paymentCountryId=${price.paymentCountryId}`
    );
  };
  return (
    <div className="box-card">
      <ServerImage className="logo" src={image?.fullPath} alt="" />
      <h1 className="title">{json(addOnName)}</h1>
      <p className="info">{json(featuredTag)}</p>
      {hasLabel && <ColoredLabel color={label.color}>{json(label.name)}</ColoredLabel>}

      <p className="content">{json(description)}</p>
      {price ? (
        <p className="price">
          {price?.netPrice}
          <small> { json(price?.currencySymbol)}</small>
        </p>
      ) : (
        ""
      )}
      <div className="d-flex">
        {<span className="type">{json(`${showDiscriminate(`${price?.discrimination}`)}`)}</span>}
        {isPurshased && (
          <span className="renew">
            {t("myProducts.addonPage.renew")}:{formatDate(purshasedData?.renewalDate)}
          </span>
        )}
      </div>
      <CanLoadGuard>
      {price && (
        <>
          {isPurshased ? (
            <>
              {purshasedData?.licenseRenewalDate < moment.utc().format() ? (
                <>
                  <Link className="expired" to={`/addon-license/${id}?addonSubscriptionId=${addonSubscriptionId}`}>
                    <img src={Missing} alt="" />
                    {t("myProducts.addonPage.expired")}
                  </Link>
                  <Link className="download" to="/invoices/unpaid">
                    {t("myProducts.addonPage.goUpPaidInvo")}
                  </Link>
                </>
              ) : (
                <>
                  <Link className="purchased" to={`/addon-license/${id}?addonSubscriptionId=${addonSubscriptionId}`}>
                    {t("myProducts.addonPage.purchased")}
                  </Link>

                  {purshasedData?.statusId === 1 && (
                    <span className="in-Progress">{t("myProducts.addonPage.inProgress")}</span>
                  )}
                  {purshasedData?.statusId === 0 && (
                    <p className="generate" onClick={openActivationFile}>
                      {t("myProducts.addonPage.generate")}
                    </p>
                  )}
                  {purshasedData?.statusId === 2 && (
                    <Button
                      className="download"
                      onClick={() => downloadFile(purshasedData?.file)}
                    >
                      {t("myProducts.addonPage.downloadFile")}{" "}
                    </Button>
                  )}
                </>
              )}
            </>
          ) : (
            <Button className="btn-blue" onClick={handleBuy}>
              {t("myProducts.addonPage.buy")}
            </Button>
          )}
        </>
      )}
      </CanLoadGuard>
      <ActivationFile show={showActivationFile} onHide={closeActivationFile} addOnId={addonSubscriptionId} />

    </div>
    
  );
};

export default AddonsCad;
